import { useEffect, useState } from "react";
import { Crown, Flame } from "lucide-react";
import { api } from "@/lib/api";
import DeathCard from "@/components/game/DeathCard";

export default function VictoryScreen({ run, onNewRun }) {
  const [card, setCard] = useState(null);
  useEffect(() => {
    if (!run?.share_id) return;
    let cancelled = false;
    api.get(`/cards/${run.share_id}`)
      .then((c) => { if (!cancelled) setCard(c); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [run?.share_id]);
  return (
    <div className="panel p-10 text-center fade-up relative overflow-hidden" data-testid="victory-screen"
         style={{ boxShadow: "0 0 60px rgba(212,175,55,0.35), inset 0 0 60px rgba(212,175,55,0.15)" }}>
      <div className="flex items-center justify-center gap-2 gold-text">
        <Crown size={18} />
        <span className="text-xs tracking-[0.5em]">THE EMBER RETURNS</span>
        <Crown size={18} />
      </div>
      <h2 className="font-heading text-5xl md:text-6xl mt-3 text-[#f0e6d2] italic">
        You have slain the <span className="gold-text">Ember King</span>
      </h2>
      <p className="font-narrative text-lg mt-4 ash-text max-w-2xl mx-auto">
        {run.current_narrative}
      </p>
      <p className="font-narrative text-base mt-4 gold-text italic max-w-xl mx-auto">
        Dawn breaks over Valdrin for the first time in a thousand years.
        The Ember's Heart rests in your palm, warm and steady. The dusk is lifted.
      </p>
      <div className="mt-8 grid grid-cols-3 max-w-md mx-auto gap-4">
        <div>
          <div className="text-[10px] tracking-[0.3em] ash-text">FLOORS</div>
          <div className="font-heading text-3xl gold-text">{run.floor}</div>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.3em] ash-text">GOLD</div>
          <div className="font-heading text-3xl gold-text">{run.gold}</div>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.3em] ash-text">TURNS</div>
          <div className="font-heading text-3xl text-[#f0e6d2]">{run.turn}</div>
        </div>
      </div>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <button onClick={onNewRun} className="btn-primary flex items-center gap-2" data-testid="victory-new-run-btn">
          <Flame size={14} /> BEGIN A NEW LEGEND
        </button>
      </div>

      {/* Shareable Victory Card */}
      {card && (
        <div className="mt-10 text-left">
          <DeathCard card={card} embedded />
        </div>
      )}
    </div>
  );
}
